import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getPositionsMachines(options = {}) {
    return _apiRequestWrap(
        ModulesMap.POSITIONS_MACHINES,
        ModulesConfigMap[ModulesMap.POSITIONS_MACHINES].GET_POSITIONS_MACHINES,
        options
    )
}

function _getPositionsMachine(options = {}) {
    return _apiRequestWrap(
        ModulesMap.POSITIONS_MACHINES,
        ModulesConfigMap[ModulesMap.POSITIONS_MACHINES].GET_POSITIONS_MACHINE,
        options
    )
}

function _getPositionsMachineOnTimePoint(options = {}) {
    return _apiRequestWrap(
        ModulesMap.POSITIONS_MACHINES,
        ModulesConfigMap[ModulesMap.POSITIONS_MACHINES].GET_POSITIONS_ON_TIME_POINT,
        options
    )
}

export default {
    [ModulesConfigMap[ModulesMap.POSITIONS_MACHINES].GET_POSITIONS_MACHINES]: _getPositionsMachines,
    [ModulesConfigMap[ModulesMap.POSITIONS_MACHINES].GET_POSITIONS_MACHINE]: _getPositionsMachine,
    [ModulesConfigMap[ModulesMap.POSITIONS_MACHINES].GET_POSITIONS_ON_TIME_POINT]: _getPositionsMachineOnTimePoint
}